import React from 'react'
import Upcoming from './UpcomingSeminars'

const UpcomingSeminars = ({rooms, selectConference, fetchConferenceDetails, ...rest}) => (
  <Upcoming
    selectConferenceId={rest.selectConferenceId}
    rooms={rooms}
    selectConference={selectConference}
    guest={rest.guest}
    fetchConferenceDetails={fetchConferenceDetails}/>
)

export default UpcomingSeminars



// WEBPACK FOOTER //
// ./src/components/Seminars/UpcomingSeminars/index.js